import {Lead} from '../data/domain/lead';
import {SubscriptionDTO} from '@minutespourtoi/api-models/dist/models';

export const leadToGA = (leadDTO: Lead) => {
  return {
    currency: 'EUR',
    value: Number(leadDTO?.price),
    coupon: leadDTO?.discount?.discountCode,
    items: [
      {
        item_id: leadDTO?.sessionId,
        item_name: `Speed dating ${leadDTO?.sessionId}`,
        price: Number(leadDTO?.price),
        quantity: 1,
        discount: Number(leadDTO?.discount?.amountInEuros || 0),
        coupon: leadDTO?.discount?.discountCode
      }
    ]
  }
}

export const subToGA = (subscriptionDTO: SubscriptionDTO) => {
  return {
    currency: 'EUR',
    value: Number(subscriptionDTO?.payment?.amount ?? 0),
    transaction_id: subscriptionDTO?.id,
    items: [
      {
        item_id: subscriptionDTO?.sessionId,
        item_name: `Speed dating ${subscriptionDTO?.sessionId}`,
        price: Number(subscriptionDTO?.payment?.amount ?? 0),
        quantity: 1,
      }
    ]
  }
}
